import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const CommonBtn = ({ name, clickFunc, btnStyle, icon, icon2, disabled, id, className }) => {
  const isIconBtn = btnStyle === "icon-btn";

  return (
    <button
      className={`btn ${!isIconBtn ? "default-btn" : ""} ${btnStyle} ${className || ""}`}
      disabled={disabled}
      onClick={() => clickFunc(name)}
      id={id}
    >
      {isIconBtn && icon2}
      {name}
      {isIconBtn && icon}
    </button>
  );
};

CommonBtn.propTypes = {
  name: PropTypes.string.isRequired,
  clickFunc: PropTypes.func.isRequired,
  btnStyle: PropTypes.string,
  icon: PropTypes.node,
  icon2: PropTypes.node,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
};

CommonBtn.defaultProps = {
  btnStyle: "default-btn",
  icon: null,
  icon2: null,
  disabled: false,
  id: "",
  className: "",
};

export default CommonBtn;



